<template>
<!-- eslint-disable -->
  <div class="indented">
    <h3>{{ name }}</h3>
    <div v-for="product in selectedalternativeproduct">
      <div class="form-horizontal">
        <h4>Alternative Product Details</h4>
        <hr />
        <div class="form-group spaced">
          Name:
          <div class="col-md-10">
            {{ product.productname }}
          </div>
        </div>

        <div class="form-group spaced">
          Description:
          <div class="col-md-10">
            {{ product.description }}
          </div>
        </div>

        <div class="form-group spaced">
          Price:
          <div class="col-md-10">
            € {{ product.price }}
          </div>
        </div>
        <div class="spacer"></div>
        <div class="form-group spaced">
          Picture:
          <div class="col-md-10">
            <img id='image' :src="$options.filters.removetilde(product.picture)">
          </div>
        </div>
        <div class="form-group spaced">
          <div class="spacer"></div>
            <div class="col-md-10">
              <a href="#" @click="goBack"><< Back</a>
            </div>
        </div>
      </div>
    </div>
  </div>

</template>

<script>
  export default {
    name: 'Comp_AlternativeProductDetails',
    props: ['selectedalternativeproduct'],
    data() {
      return {

      }
    },
    methods: {
      goBack() {
        this.$router.push('/ProductDetails');
      }
    },
    filters: {
      removetilde: function (string) {
        var firstChar = string.charAt(0);
        if (firstChar == '~') {
          return string.substring(1, string.length);
        }
        else {
          return string;
        }
      }
    }
  }
</script>

<style scoped src="bootstrap/dist/css/bootstrap.min.css">

  /* install bootstrap first by typing 'npm install bootstrap' in command prompt */
</style>

<style scoped>


  .indented {
    margin: 20px;
    max-width: 550px;
  }

  .spacer {
    height: 25px;
    border: 0px solid black;
    clear: both;
  }

  .smallspacer {
    height: 5px;
    border: 0px solid black;
    clear: both;
  }

  .spaced {
    margin-bottom: 10px;
  }

  .image {
    width: 90px;
    float: left;
    margin-right: 20px;
  }

  .button {
    border: 1px solid gray;
  }

  .prodname {
    font-size: 10px;
  }

  .proditem {
    float: left;
    margin-right: 15px;
  }
</style>




// WEBPACK FOOTER //
// src/Comp_AlternativeProductDetails.vue